import React, {useEffect, useState} from "react";
import Api from "../../Api";
import {useHistory, useParams} from "react-router-dom";
import {withAuth} from "../../hoc/Auth";
import EmptyCard from "../../hoc/EmptyCard";
import VTabBar from "../../Components/Utils/VTabBar";
import TabBarItem from "../../Components/Utils/VTabBar/TabBarItem";
import Loader from "../../Components/Utils/Loader";
import FormatDate from "../../Components/Utils/FormatDate";
import isEmpty from "../../Components/Utils/IsEmpty";
import Icon from "../../Components/Utils/Icon";
import {FormattedMessage} from "react-intl";

import classes from "./styles.module.css";

function PrepaidDetails({token}) {
    const EAN = useParams().EAN;
    const history = useHistory();

    const [details, setDetails] = useState({});
    const [loading, setLoading] = useState(true);

    const gender = (val) => {
        switch (val) {
            case "0":
                return <FormattedMessage id="PrepaidDetails.gender.female" defaultMessage="Женский"/>;
            case "1":
                return <FormattedMessage id="PrepaidDetails.gender.male" defaultMessage="Мужской"/>;
            default:
                return isEmpty();
        }
    };

    const handleActivate = () => {
        history.push(`/prepaid/activate/${EAN}`);
    };

    useEffect(() => {
        new Api({token}).getPreActivatedCardDetails(EAN).then((r) => {
            if (r.activationData != null) {
                setDetails(r);
            } else {
                setDetails({
                    ...r,
                    activationData: {
                        legalAddress: {value: ""},
                        residenceAddress: {value: ""},
                    },
                });
            }
            setLoading(false);
        });
    }, [EAN, token]);

    // Безопасное получение значений
    const getValue = (obj, path, fallback = "") => {
        return path.reduce((acc, key) => (acc && acc[key] != null ? acc[key] : fallback), obj);
    };

    return (
        <div className={`${classes.containerFluid} d-flex flex-column min-vh-100`}>
            <div className="row flex-grow-1">
                <div className="col-12 pt-2">
                    {loading ? (
                        <Loader/>
                    ) : (
                        <EmptyCard
                            title={<FormattedMessage id="Prepaid.title.details" defaultMessage="Детализация карты"/>}
                            subtitle={
                                <FormattedMessage
                                    id="PrepaidDetails.subtitle.ean"
                                    defaultMessage="EAN: {ean} ({part})"
                                    values={{
                                        ean: EAN,
                                        part: (details.part || "").replace(/[*]{6}/g, " •••• "),
                                    }}
                                />
                            }
                        >
                            <div className={classes.Card}>
                                <VTabBar className={classes.TabBar}>
                                    <TabBarItem
                                        label={<FormattedMessage id="PrepaidDetails.tab.passport"
                                                                 defaultMessage="Паспортные данные"/>}
                                        navIcon="file-text"
                                        isVisible={true}
                                    >
                                        <table className={classes.TabTable}>
                                            <tbody>
                                            <tr>
                                                <td><FormattedMessage id="PrepaidDetails.label.docSerial"
                                                                      defaultMessage="Серия документа:"/></td>
                                                <td>{isEmpty(getValue(details, ['activationData', 'docSerial']))}</td>
                                            </tr>
                                            <tr>
                                                <td><FormattedMessage id="PrepaidDetails.label.docNumber"
                                                                      defaultMessage="Номер документа:"/></td>
                                                <td>{isEmpty(getValue(details, ['activationData', 'docNumber']))}</td>
                                            </tr>
                                            <tr>
                                                <td><FormattedMessage id="PrepaidDetails.label.docIssuer"
                                                                      defaultMessage="Кем выдан:"/></td>
                                                <td>{isEmpty(getValue(details, ['activationData', 'docIssuer']))}</td>
                                            </tr>
                                            <tr>
                                                <td><FormattedMessage id="PrepaidDetails.label.docIssuedDate"
                                                                      defaultMessage="Дата выдачи:"/></td>
                                                <td>
                                                    <FormatDate
                                                        setDate={getValue(details, ['activationData', 'docIssuedDate'])}
                                                        format={{day: "numeric", month: "numeric", year: "numeric"}}
                                                        isEmpty
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><FormattedMessage id="PrepaidDetails.label.docIssuerCode"
                                                                      defaultMessage="Код подразделения:"/></td>
                                                <td>{isEmpty(getValue(details, ['activationData', 'docIssuerCode']))}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </TabBarItem>

                                    <TabBarItem
                                        label={<FormattedMessage id="PrepaidDetails.tab.personal"
                                                                 defaultMessage="Личные данные"/>}
                                        navIcon="user"
                                        isVisible={true}
                                    >
                                        <table className={classes.TabTable}>
                                            <tbody>
                                            <tr>
                                                <td><FormattedMessage id="PrepaidDetails.label.lastName"
                                                                      defaultMessage="Фамилия:"/></td>
                                                <td>{isEmpty(getValue(details, ['activationData', 'secondName']))}</td>
                                            </tr>
                                            <tr>
                                                <td><FormattedMessage id="PrepaidDetails.label.firstName"
                                                                      defaultMessage="Имя:"/></td>
                                                <td>{isEmpty(getValue(details, ['activationData', 'firstName']))}</td>
                                            </tr>
                                            <tr>
                                                <td><FormattedMessage id="PrepaidDetails.label.patronymic"
                                                                      defaultMessage="Отчество:"/></td>
                                                <td>{isEmpty(getValue(details, ['activationData', 'patronymic']))}</td>
                                            </tr>
                                            <tr>
                                                <td><FormattedMessage id="PrepaidDetails.label.gender"
                                                                      defaultMessage="Пол:"/></td>
                                                <td>{gender(getValue(details, ['activationData', 'gender']))}</td>
                                            </tr>
                                            <tr>
                                                <td><FormattedMessage id="PrepaidDetails.label.birthday"
                                                                      defaultMessage="Дата рождения:"/></td>
                                                <td>
                                                    <FormatDate
                                                        setDate={getValue(details, ['activationData', 'birthday'])}
                                                        format={{day: "numeric", month: "numeric", year: "numeric"}}
                                                        isEmpty
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><FormattedMessage id="PrepaidDetails.label.birthPlace"
                                                                      defaultMessage="Место рождения:"/></td>
                                                <td>{isEmpty(getValue(details, ['activationData', 'birthPlace']))}</td>
                                            </tr>
                                            <tr>
                                                <td><FormattedMessage id="PrepaidDetails.label.birthCountry"
                                                                      defaultMessage="Страна рождения:"/></td>
                                                <td>{isEmpty(getValue(details, ['activationData', 'birthCountry']))}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </TabBarItem>

                                    <TabBarItem
                                        label={<FormattedMessage id="PrepaidDetails.tab.contacts"
                                                                 defaultMessage="Контактная информация"/>}
                                        navIcon="envelop"
                                        isVisible={true}
                                    >
                                        <table className={classes.TabTable}>
                                            <tbody>
                                            <tr>
                                                <td><FormattedMessage id="PrepaidDetails.label.phone"
                                                                      defaultMessage="Телефон:"/></td>
                                                <td>{isEmpty(getValue(details, ['activationData', 'phone']))}</td>
                                            </tr>
                                            <tr>
                                                <td><FormattedMessage id="PrepaidDetails.label.legalAddress"
                                                                      defaultMessage="Адрес регистрации:"/></td>
                                                <td>{isEmpty(getValue(details, ['activationData', 'legalAddress', 'value']))}</td>
                                            </tr>
                                            <tr>
                                                <td><FormattedMessage id="PrepaidDetails.label.residenceAddress"
                                                                      defaultMessage="Адрес фактического проживания:"/>
                                                </td>
                                                <td>{isEmpty(getValue(details, ['activationData', 'residenceAddress', 'value']))}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </TabBarItem>
                                </VTabBar>

                                {(details.status === 0 || details.status === 3) && (
                                    <div className={classes.Footer}>
                                        <div className={classes.Btn} onClick={handleActivate}>
                                            <Icon className={classes.IconLeft} icon="checkmark" size={"16px"}/>
                                            <FormattedMessage id="PrepaidDetails.button.activate"
                                                              defaultMessage="Активировать"/>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </EmptyCard>
                    )}
                </div>
            </div>
        </div>
    );
}

export default withAuth(PrepaidDetails);


// WEBPACK FOOTER //
// ./src/PagesOfUser/PrepaidDetails/index.jsx